import React from 'react';
import formatNumber, { formatDate } from '../../utils/functions';
import { APP_NAME } from '../../utils';

const CHANNEL_ROWS = [
  { key: 'showroom', label: 'Showroom' },
  { key: 'carreaux_casses', label: 'Carreaux cassés' },
  { key: 'total', label: 'Total global', isTotal: true },
];

const fmt = (value) => `${formatNumber(value ?? 0)} FCFA`;

export default function FinanceTaxReportPrint({ report, periodLabel }) {
  if (!report) return null;

  const total = report.total ?? {};

  return (
    <div className="invoice-copy">
      <div className="flex flex-row justify-between items-start mt-10">
        <div>
          <img src="/assets/img/logo_v2.png" height={100} width={100} alt={APP_NAME} />
          <p className="font-medium text-sm mt-3">C/1775 C, QUARTIER GBEDJEKOME - OUEDO</p>
          <p className="font-medium text-sm">IFU 3202434985932</p>
          <p className="font-medium text-sm">info@asebat.com</p>
          <p className="font-medium text-sm">+229 01 61 89 89 00</p>
        </div>
        <div className="text-end">
          <p className="font-medium text-sm">
            <span className="font-semibold">Période</span> : {periodLabel}
          </p>
          <p className="font-medium text-sm">
            <span className="font-semibold">Édité le</span> : {formatDate(new Date().toISOString())}
          </p>
        </div>
      </div>

      <p className="text-right mt-4 font-medium text-xl">
        <span className="font-bold">Rapport Finance &amp; Impôts</span>
      </p>

      <div className="overflow-x-auto">
        <table className="border-collapse mt-3 w-full text-sm whitespace-pre table-auto">
          <thead>
            <tr>
              <th className="p-2 border font-semibold text-start">Canal</th>
              <th className="p-2 border font-semibold text-end">Ventes</th>
              <th className="p-2 border font-semibold text-end">Montant HT</th>
              <th className="p-2 border font-semibold text-end">TVA</th>
              <th className="p-2 border font-semibold text-end">AIB</th>
              <th className="p-2 border font-semibold text-end">Montant TTC</th>
            </tr>
          </thead>
          <tbody>
            {CHANNEL_ROWS.map(({ key, label, isTotal }) => {
              const bucket = report[key];
              if (!bucket) return null;
              const rowClass = isTotal ? 'bg-gray-100' : '';
              return (
                <tr key={key} className={rowClass}>
                  <td className={`p-2 border font-medium${isTotal ? ' font-semibold' : ''}`}>{label}</td>
                  <td className="p-2 border font-medium text-end">{bucket.nombre_ventes ?? 0}</td>
                  <td className="p-2 border font-medium text-end">{fmt(bucket.montant_ht)}</td>
                  <td className="p-2 border font-medium text-end">{fmt(bucket.tva)}</td>
                  <td className="p-2 border font-medium text-end">{fmt(bucket.aib)}</td>
                  <td className="p-2 border font-medium text-end">{fmt(bucket.montant_ttc)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div className="overflow-x-auto mt-2">
        <table className="border-collapse w-full text-sm whitespace-pre table-auto">
          <tbody>
            <tr>
              <td colSpan={3} className="p-2 border font-semibold text-sm">
                Synthèse consolidée
              </td>
              <td colSpan={2} className="p-2 border font-semibold text-end text-sm">
                <b>Montant HT :</b> {fmt(total.montant_ht)}
              </td>
            </tr>
            <tr>
              <td colSpan={3} rowSpan={3} className="border-e-0 p-2 border font-medium text-sm align-top">
                Rapport de synthèse des ventes showroom et carreaux cassés sur la période indiquée.
                Document interne — sans détail des achats ni des lignes de facture.
                <br />
                <br />
                {APP_NAME} © {new Date().getFullYear()}
              </td>
            </tr>
            <tr>
              <td colSpan={2} className="p-2 border font-semibold text-end text-sm">
                <b>T.V.A (18%) :</b> {fmt(total.tva)}
              </td>
            </tr>
            <tr>
              <td colSpan={2} className="p-2 border font-semibold text-end text-sm">
                <b>AIB :</b> {fmt(total.aib)}
              </td>
            </tr>
            <tr>
              <td colSpan={3} className="p-2 border-0" />
              <td colSpan={2} className="p-2 border font-bold text-end text-sm">
                <b>Total TTC encaissé :</b> {fmt(total.montant_ttc)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export { CHANNEL_ROWS };
